module.exports = __webpack_public_path__ + "media/scholarship_winners/ali-sw-ffe4f118.png";